import { BaseAction } from "../../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { ICustomerContact } from "../../../../Orchestrator/Types/Index";
import { UpdateCustomerContactForm } from "../../../../Orchestrator/Types/Types/Passenger/PassengerType";

export class UpdateContactFormDataAction extends BaseAction<{updatedCustomer: ICustomerContact | null}, UpdateCustomerContactForm> {

    sanitizeName = (
        value: string | Date | null,
        field: string
    ): string | Date | null => {
        if (
            (field === "firstName" || field === "lastName") &&
            typeof value === "string"
        ) {
            return value.replace(/[^\p{L}\p{M}\s-]/gu, "");
        }
        return value;
    };

    override async run(): Promise<{updatedCustomer: ICustomerContact | null}> {
        let updatedCustomer: ICustomerContact | null = null;
        try {
            const { field, value, customerContact } = this.params!;
            // `customerContact` is the snapshot the emitting component read at
            // RENDER time, not the live atom. Browser autofill writes several
            // contact fields inside a single task, so every one of those emits
            // carries the same pre-autofill snapshot — spreading it would make
            // each field's write erase the previous one and only the last field
            // would survive. Merge onto the live atom instead (same convention
            // as SyncContactPassengerDataAction), falling back to the snapshot
            // when the atom has not been seeded yet.
            const latestContact =
                getRecoilStateValue<ICustomerContact>("customerContactStateAtom") ||
                customerContact;
            const updatedContact = {
                ...customerContact,
                ...latestContact,
                [field]: this.sanitizeName(value, field as string),
            };
            updateRecoilState("customerContactStateAtom", updatedContact);
            updatedCustomer = updatedContact
        } catch (error) {
            console.error("Error in UpdateContactFormDataAction:", error);
        } finally {
            return { updatedCustomer }
        }
    }
}

// Create a singleton instance
export const updateContactFormDataAction = new UpdateContactFormDataAction(); 